import { useCallback } from 'react';
import reduce from 'lodash/reduce';
import without from 'lodash/without';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';
import { WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS } from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';
import { UNASSIGNED_REQUEST_TYPE } from '../../common/constants';
import type { TicketType } from '../../common/types';
import { useTicketTypesByPracticesSubscriber } from '../../services/store';
import useGetTicketTypesByGroup from '../get-ticket-types-by-group';
import messages from './messages';

type Options = {
	label: string;
	options: TicketType[];
}[];

const PRACTICE_LABEL_MAP: Record<string, MessageDescriptor> = {
	...WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS,
	[UNASSIGNED_REQUEST_TYPE]: messages.unassigned,
} as const;

const useGetRequestFormOptions = (groupId: number) => {
	const { formatMessage } = useIntl();
	// go/jfe-eslint
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const ticketTypesInGroup = useGetTicketTypesByGroup(groupId) || [];
	const [ticketTypesByPractices] = useTicketTypesByPracticesSubscriber();

	return useCallback(
		(): Options =>
			reduce(
				ticketTypesByPractices,
				(acc: Options, ticketTypes: TicketType[], key: string) => {
					const labelMessage = PRACTICE_LABEL_MAP[key];

					return [
						...acc,
						{
							label: labelMessage ? formatMessage(labelMessage) : '',
							options: without<TicketType>(ticketTypes, ...ticketTypesInGroup),
						},
					];
				},
				[],
			),
		[formatMessage, ticketTypesByPractices, ticketTypesInGroup],
	);
};

export default useGetRequestFormOptions;
